import styled from 'styled-components';

export const InforCardContainer = styled.div`
  /* border: 1px solid red; */
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.spacing.xs};
  /* margin: ${({ theme }) => theme.spacing.xs}; */
  background-color: ${({ theme }) => theme.colors.offWhite};
  color: ${({ theme }) => theme.colors.grey6};
  margin-block: ${({ theme }) => theme.spacing.s};
  div {
    width: 100%;
  }
  span {
    border-bottom: 2px solid ${({ theme }) => theme.colors.orange4};
  }
  @media screen and (width <= 768px) {
    padding: ${({ theme }) => theme.spacing.xs};
  }
`;
